module.exports = __webpack_public_path__ + "img/place_cygy.073d8f99.png";